const TRACKING_GROUP_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[trackingGroupManagementExperience] createTrackingGroup',
  DELETE: '[trackingGroupManagementExperience] deleteTrackingGroup',
  UPDATE_ATTRIBUTE_ACTIVE: '[trackingGroupManagementExperience] updateAttributeActive'
}

export default TRACKING_GROUP_MANAGEMENT_EXPERIENCE_TYPES
